import { queries } from '@/shared/lib/tanstack-query/query-keys'
import { useQueries } from '@tanstack/react-query'

export const useNotificationInfo = (id: string) => {
  return useQueries({
    queries: [
      queries.products.detail(id),
      queries.products.notificationStatus(id),
    ],
    combine: (results) => {
      const detail = results[0].data
      if (!detail) return { pending: true, data: null }
      const notification = results[1].data
      const hasNotification =
        notification &&
        (notification.isPriceReachNoti || notification.isRestockNoti)

      const isReached =
        hasNotification &&
        (notification?.notifiedPrice ?? 0) >= detail.price?.price
      return {
        pending: results.some((result) => result.isPending),
        data: {
          price: detail.price,
          id: notification?.notifications?.length,
          hasNotification,
          linkUrl: detail.linkUrl,
          notificationPrice: notification?.notifiedPrice,
          isReached,
        },
      }
    },
  })
}
